import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUnit } from "../../../../../../Store/Store/StoreMaster/Unit/Unit";

const ItemDetails = ({
  items,
  itemErrors,
  handleItemChange,
  handleItemBlur,
  handleAddItem,
  handleRemoveItem,
  canAddMoreItems,
  isLoading,
  error,
}) => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUnit())
  }, [])

  const unitData = useSelector((state) => state?.getUnit?.user?.data);

  return (
    <>
      <div className="row mt-4">
        <div className="col-12">
          <div className="form-heading d-flex justify-content-between align-items-center mb-3">
            <div>
              <h4 className="mb-0">Item Details</h4>
            </div>
            <button
              type="button"
              className="btn add-pluss"
              style={{
                backgroundColor: "var(--primary-clr)",
                color: "white",
              }}
              onClick={handleAddItem}
              disabled={!canAddMoreItems || isLoading}
              title={
                !canAddMoreItems
                  ? "Complete current item details to add more"
                  : "Add new item"
              }
            >
              <i className="fa fa-plus me-1"></i> Add Item
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead className="table-light">
                <tr>
                  <th
                    style={{ width: "5%", verticalAlign: "middle" }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th
                    style={{
                      width: "25%",
                      verticalAlign: "middle",
                    }}
                  >
                    Item Name <span className="text-danger">*</span>
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    Unit <span className="text-danger">*</span>
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    HSN No
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    Weight
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    Quantity
                    {/* <span className="text-danger">*</span> */}
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    Rate (₹)
                  </th>
                  <th
                    style={{
                      width: "12%",
                      verticalAlign: "middle",
                    }}
                  >
                    Amount (₹)
                  </th>
                  <th
                    style={{
                      width: "10%",
                      verticalAlign: "middle",
                    }}
                    className="text-center"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr
                    key={index}
                    className={
                      itemErrors[index]?.name ||
                        itemErrors[index]?.qty ||
                        itemErrors[index]?.rate
                        ? ""
                        : ""
                    }
                  >
                    <td className="text-center align-middle">
                      <strong>{index + 1}</strong>
                    </td>
                    <td>
                      <input
                        type="text"
                        className={`form-control form-control-sm ${itemErrors[index]?.name ? "is-invalid" : ""
                          }`}
                        value={item?.name}
                        onChange={(e) =>
                          handleItemChange(index, "name", e.target.value)
                        }
                        onBlur={() => handleItemBlur(index, "name")}
                        placeholder="Enter item name"
                      />
                      {itemErrors[index]?.name && (
                        <small className="text-danger">
                          {itemErrors[index].name}
                        </small>
                      )}
                    </td>
                    <td>
                      <select
                        className={`form-control form-control-sm ${itemErrors[index]?.unit ? "is-invalid" : ""
                          }`}
                        value={item?.unit || ""}
                        onChange={(e) =>
                          handleItemChange(index, "unit", e.target.value)
                        }
                        onBlur={() => handleItemBlur(index, "unit")}
                      >
                        <option value="">Select Unit</option>
                        {unitData?.map((unit) => (
                          <option key={unit._id} value={unit._id}>
                            {unit.name}
                          </option>
                        ))}
                      </select>
                      {itemErrors[index]?.unit && (
                        <small className="text-danger">
                          {itemErrors[index].unit}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={item.hsn}
                        onChange={(e) =>
                          handleItemChange(index, "hsn", e.target.value)
                        }
                        placeholder="HSN"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={item.weight}
                        onChange={(e) =>
                          handleItemChange(index, "weight", e.target.value)
                        }
                        placeholder="Weight"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className={`form-control form-control-sm ${itemErrors[index]?.qty ? "is-invalid" : ""
                          }`}
                        value={item.qty}
                        onChange={(e) =>
                          handleItemChange(index, "qty", e.target.value)
                        }
                        onBlur={() => handleItemBlur(index, "qty")}
                        placeholder="0"
                        min="0"
                        step="0.01"
                      />
                      {itemErrors[index]?.qty && (
                        <small className="text-danger">
                          {itemErrors[index].qty}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="number"
                        className={`form-control form-control-sm ${itemErrors[index]?.rate ? "is-invalid" : ""
                          }`}
                        value={item.rate}
                        onChange={(e) =>
                          handleItemChange(index, "rate", e.target.value)
                        }
                        onBlur={() => handleItemBlur(index, "rate")}
                        placeholder="0.00"
                        min="0"
                        step="0.01"
                      />
                      {itemErrors[index]?.rate && (
                        <small className="text-danger">
                          {itemErrors[index].rate}
                        </small>
                      )}
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control form-control-sm bg-light"
                        value={`₹ ${item.amount}`}
                        readOnly
                        style={{ fontWeight: "600" }}
                      />
                    </td>
                    <td className="text-center align-middle">
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleRemoveItem(index, item.name)}
                        disabled={items.length === 1 || isLoading}
                        title="Delete Item"
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {error.items && (
              <div className="alert alert-danger mt-2 py-2">
                <i className="fa fa-exclamation-circle me-2"></i>
                {error.items}
              </div>
            )}
            {!canAddMoreItems && items.length > 0 && (
              <div
                className="alert mt-2 py-2"
                style={{
                  backgroundColor: "rgba(255, 105, 35, 0.1)",
                  border: "1px solid var(--primary-clr)",
                  color: "var(--primary-clr)",
                  fontSize: "12px",
                }}
              >
                <i className="fa fa-info-circle me-2"></i>
                Complete the current item details (Name, Quantity, Rate) to add
                more items
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemDetails;
